import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { PerksCategoriesWithExpenseResponse } from './getCategoriesWithExpenseTypes'

export const getEligiblePerkCategoriesToAdd = (
  productClassId: string,
  planPeriodId: string,
): Promise<PerksCategoriesWithExpenseResponse[]> => {
  return adminHttpClient.get(`AdminDashboard/Perks/GetEligibleCategoriesWithExpenseTypes`, {
    productClassId,
    planPeriodId,
  })
}
